module.exports = __webpack_public_path__ + "static/assets/6cfbdc45842635b700715d97cad9b44c.svg";